
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moje-uslugi/reaktywacja/usluga-reaktywowana",
      function () {
        return require("private-next-pages/moje-konto/moje-uslugi/reaktywacja/usluga-reaktywowana.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moje-uslugi/reaktywacja/usluga-reaktywowana"])
      });
    }
  